import { useMemo, useState } from 'react';

import Input from '@preqin/ui-components/cjs/core/Forms/Input/Input.Form.js';
import Modal from '@preqin/ui-components/cjs/core/Modal';
import { CircleDash } from '@preqin/ui-components/cjs/icons/operations';

import { ModalProps } from './ModalProps';

export const ReportFilterSaveModal = ({ isOpen, isLoading, filters, handleCancel, handleSubmit }: ModalProps) => {
  const [inputValue, setInputValue] = useState<string>();
  const [validationError, setValidationError] = useState<boolean>(false);

  const existFilterNames: string[] = useMemo(() => filters?.map((filter) => filter.name), [filters]);

  const handleInputChange = (input) => {
    setValidationError(existFilterNames.includes(input));
    setInputValue(input);
  };

  return (
    <Modal
      headerTitle="Save Search"
      isOpen={isOpen}
      size="md"
      primaryButtonDisabled={isLoading || validationError}
      primaryButtonText={isLoading ? 'Saving' : 'Save search'}
      primaryButtonLoading={isLoading}
      primaryButtonIconEnd={isLoading ? <CircleDash height={16} width={16} /> : null}
      handleOnModalToggleFunction={handleCancel}
      handleOnModalPrimaryButtonClick={() => handleSubmit(inputValue)}
      handleOnModalSecondaryButtonClick={handleCancel}
      bodyContent={
        <Input
          onChange={(e) => handleInputChange(e.target.value)}
          placeholder="Enter a save search name"
          labelText="Name"
          showLabel={true}
          styleType={validationError ? 'negative' : 'default'}
          validationMessage={validationError ? 'This saved search name already exist' : null}
        />
      }
    />
  );
};
